'use strict';

const $ = require('jquery');
const inputfields = require('../utils/inputfields');
const uniform = require('../components/uniform');
const validator = require('../utils/validator');
const progress = require('../utils/progress');
const dialogUtils = require('../utils/dialogUtil');
const friendlyCaptcha = require('../widgets/friendlyCaptcha');
const captcha = require('../spam/captcha');

const CLASS_REQUIRED = 'required';
const CLASS_HIDDEN = 'hidden';
const CLASS_ERROR_MSG = 'error-msg';
const CLASS_VALIDATION_ERROR = 'validation-error';

const ATTR_PLACEHOLDER = 'placeholder';

const Dialog = require('../lib/dialog').default;

let previouslySelectedReturnReason = false;

/**
 * @function
 * @description submit and renders response
 **/
function submitContactForm($form) {
    const data = $form.serialize(),
        $contactFormInclude = $form.closest('.contactFormInclude');

    $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: data,
        beforeSend: () => {
            progress.show($contactFormInclude);
        }
    })
        .done(function (response) {
            if (!response.error) {
                $contactFormInclude.html(response);
            } else {
                $('.template-error').removeClass('hidden');
            }
            if (typeof $('.contact-us-confirmation').first().offset() !== 'undefined') {
                window.scrollTo(
                    0,
                    $('.contact-us-confirmation').first().offset().top - $('.header-wrapper:visible').height()
                );
            }

            setContactFormHandler();
            inputfields.init();
            validator.init();
            uniform();
        })
        .always(() => {
            progress.hide();
        });
}

/**
 * @function
 * @description renders contactform from response
 **/
function getNewContactForm($button) {
    const $contactFormInclude = $button.closest('.contactFormInclude');

    $.ajax({
        type: 'GET',
        url: $button.attr('href')
    }).done(function (response) {
        $contactFormInclude.html(response);
        setContactFormHandler();
        inputfields.init();
        validator.init();
        uniform();
        friendlyCaptcha.reset('#ContactForm .frc-captcha');
        const $contactForm = $contactFormInclude.find('form');
        captcha.resetCaptcha($contactForm[0]);
        initializeContactUsFeature();
        initializeContactUsRedirect();
    });
}

/**
 * @function
 * @description open modal after pushing the call phone block
 **/

$('body').on('click', '.contact-link--phone, .contact-link--popup', function (e) {
    e.preventDefault();

    const contactType = $(this).data('contact-type') || 'contactPhoneOverlay';

    const dialog = new Dialog({
        additionalClasses: ['contact-modal'],
        canCloseOnBackdropClick: true,
        url: Urls[contactType],
        useLegacyContainer: true,
        hasTitleBar: false,
        hasCloseText: false,
        callback: dialogUtils.commonDialogCallback,
        closeCallback: dialogUtils.commonDialogCloseCallback
    });

    dialog.open();
});

/**
 * @function
 * @description Validation of the customer's message when typing
 **/
$('body').on('keyup', '.contact-us-form .input-textarea', function (e) {
    inputfields.init();
    $(this).valid();
});
/**
 * @function
 * @description Validation of the customer's message when pasting
 **/
$('body').on('paste', '.contact-us-form .input-textarea', function (e) {
    e.preventDefault();
    let clipboardText = e.originalEvent.clipboardData.getData('text').trim();
    let currentMessage = $(this).val() + clipboardText;
    let maxlength = $(this).attr('maxlength') || 500;
    $(this).val(currentMessage.slice(0, +maxlength));
    inputfields.init();
    $(this).valid();
});

$('body').on('click', '.contact-link--mail', function (e) {
    e.preventDefault();
    let headerHeight = $('header').height();
    let contactHeaderHeight = $('.contact-form-header').height();
    let screenWidth = window.innerWidth;
    window.scrollTo(0, $('.contactFormInclude').offset().top - headerHeight);
    if (screenWidth <= 768) {
        window.scrollTo(0, $('.contactFormInclude').offset().top - contactHeaderHeight);
    }
});

/**
 * @function
 * @description set necessary handler
 **/
function setContactFormHandler() {
    const $includeContainer = $('.contactFormInclude'),
        $includedContactForm = $includeContainer.find('form#ContactForm');

    if ($includedContactForm.length > 0) {
        $includedContactForm.on('submit', function (e) {
            e.preventDefault();
            if ($(this).valid()) {
                submitContactForm($(this));
            }
        });
    }

    $includeContainer.find('.contactus-new').on('click', function (e) {
        e.preventDefault();
        getNewContactForm($(this));
    });
}

/**
 *
 * @function
 * @description based on id show or hide additional 'returnreason' selectbox
 **/
function getReturnReason() {
    const selectedOption = $('#myquestionselect option:checked');
    const returnReasonElement = $('#uniform-dwfrm_contactus_returnreason');

    if (selectedOption[0].id === 'customerServiceQuestion-6') {
        showReturnReasonSelect(returnReasonElement);
    } else {
        hideReturnReasonSelect(returnReasonElement);
    }
    validator.init();
}

/**
 *
 * @function
 * @description opens a link to the customer service in a new tab
 **/
function redirectToCustomerService() {
    const $selectedOption = $('#myquestionselect option:checked');
    if ($selectedOption[0].id === 'customerServiceTopic-NotCustomer') {
        const topicOptions = document.querySelector('#myquestionselect');
        const firstOption = Array.from(topicOptions.options)[0];
        firstOption.selected = true;
        $selectedOption.trigger('click');
        window.open(window.Resources.CONTACT_CUSTOMER_SERVICE, '_blank');
    }
}

/**
 *
 * @function
 * @description shows the 'returnreason' select element
 **/
function showReturnReasonSelect(returnReasonElement) {
    previouslySelectedReturnReason = true;
    const returnReasonRowElement = returnReasonElement.parent();
    returnReasonRowElement.removeClass(CLASS_HIDDEN);

    if (!returnReasonElement.hasClass(CLASS_REQUIRED)) {
        returnReasonElement.addClass(CLASS_REQUIRED);

        if (!returnReasonRowElement.hasClass(CLASS_REQUIRED)) {
            returnReasonRowElement.addClass(CLASS_REQUIRED);
        }

        const innerReturnReasonElemen = returnReasonElement.find('#dwfrm_contactus_returnreason');
        if (!innerReturnReasonElemen.hasClass(CLASS_REQUIRED)) {
            innerReturnReasonElemen.addClass(CLASS_REQUIRED);
        }
    }

    const orderNumberElement = $('#dwfrm_contactus_ordernumber');
    if (!orderNumberElement.hasClass(CLASS_REQUIRED)) {
        orderNumberElement.addClass(CLASS_REQUIRED);
        let placeHolderText = orderNumberElement.attr(ATTR_PLACEHOLDER);
        placeHolderText = placeHolderText.replace(' (Optional)', '');
        orderNumberElement.attr(ATTR_PLACEHOLDER, placeHolderText);
        const orderNumberLabel = $('label[for="dwfrm_contactus_ordernumber"] span');
        let orderNumberLabelText = orderNumberLabel.text();
        orderNumberLabel.text(orderNumberLabelText.replace(' (Optional)', ''));
    }

    if (!orderNumberElement.parent().hasClass(CLASS_REQUIRED)) {
        orderNumberElement.parent().addClass(CLASS_REQUIRED);
    }
}

/**
 * hides the 'returnreason' select element
 */
function hideReturnReasonSelect(returnReasonElement) {
    if (previouslySelectedReturnReason) {
        const returnReasonRowElement = returnReasonElement.parent();
        if (!returnReasonRowElement.hasClass(CLASS_HIDDEN)) {
            returnReasonRowElement.addClass(CLASS_HIDDEN);
        }

        const innerReturnReasonElemen = returnReasonElement.find('#dwfrm_contactus_returnreason');
        innerReturnReasonElemen.prop('selectedIndex', 0);

        const orderNumberElement = $('#dwfrm_contactus_ordernumber');
        if (orderNumberElement.parent().hasClass(CLASS_REQUIRED)) {
            orderNumberElement.parent().removeClass(CLASS_REQUIRED);
        }

        if (orderNumberElement.hasClass(CLASS_REQUIRED)) {
            orderNumberElement.removeClass(CLASS_REQUIRED);
            const orderNumberLabel = $('label[for="dwfrm_contactus_ordernumber"] span');
            let orderNumberLabelText = orderNumberLabel.text();
            let placeHolderText = orderNumberElement.attr(ATTR_PLACEHOLDER);
            orderNumberElement.attr(ATTR_PLACEHOLDER, `${placeHolderText} (Optional)`);
            orderNumberLabel.text(`${orderNumberLabelText} (Optional)`);
        }

        const errorMessageElement = orderNumberElement.parent().find(`.${CLASS_ERROR_MSG}`);
        if (errorMessageElement.length) {
            errorMessageElement.remove();
        }

        if (orderNumberElement.parent().hasClass(CLASS_VALIDATION_ERROR)) {
            orderNumberElement.parent().removeClass(CLASS_VALIDATION_ERROR);
        }
    }

    previouslySelectedReturnReason = false;
}

/**
 * @function
 * @description initializes contactus seleciton feature
 */
function initializeContactUsFeature() {
    if (SitePreferences.LOAD_RETURN_REASON) {
        getReturnReason();
        document.getElementById('myquestionselect').addEventListener('change', () => getReturnReason());
    }
}

/**
 * @function
 * @description initializes redirect to customer service
 */
function initializeContactUsRedirect() {
    redirectToCustomerService();
    document.getElementById('myquestionselect').addEventListener('change', () => redirectToCustomerService());
}

const customerService = {
    init: function () {
        this.initializeEvents();
        initializeContactUsFeature();
        initializeContactUsRedirect();
    },
    initializeEvents: function () {
        setContactFormHandler();
    }
};

module.exports = customerService;
